import { BACKEND } from '@old/services/backend';
import {
  SilometrixThresholdEditionPayload,
  SilometrixThresholdEditionResponse,
} from './silometrix-threshold-edition.types';
import { ENDPOINT } from '@old/data/core/endpoints';

export async function SilometrixThresholdEditionService({ body }: SilometrixThresholdEditionPayload) {
  const { response, data } = await BACKEND.put<SilometrixThresholdEditionResponse>(
    ENDPOINT.METRICS_ALERTS_CONFIG,
    { body }
  );

  return {
    response,
    summary: data,
  };
}
